
import { useLanguageContext } from '../../contexts/LanguageContext';
import Dialog, { IDialogProps } from '../Dialog';
import { ActionButton } from '../Button';
import { Grid } from '@mui/material';
import TextField from '../TextField';
import { useUserContext } from '../../contexts/UserContext';
import { useState, useEffect, useCallback, useMemo } from 'react';
import FormHelper from '../../helpers/FormHelper';
import UserService from '../../services/UserService';
import ValidationHelper from '../../helpers/ValidationHelper';


const ChangePasswordDialog: React.FunctionComponent<Pick<IDialogProps, 'title' | 'open' | 'handleClose'>> = ({ title, open, handleClose }) => {
    const { translate } = useLanguageContext();
    const { user, handleChangeUser } = useUserContext();

    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [repeatNewPassword, setRepeatNewPassword] = useState<string>('');


    useEffect(() => {
        if (open) {
            setCurrentPassword('');
            setNewPassword('');
            setRepeatNewPassword('');
        }
    }, [open]);


    const dialogActions = useMemo(() => {
        const elements = [] as JSX.Element[];

        if (!user?.forcePasswordChange) {
            elements.push(<ActionButton action='cancel' onClick={handleClose} />);
        }

        return [
            ...elements,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate, user?.forcePasswordChange]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        UserService.ChangePassword(formData).then(() => {
            if (user) {
                handleChangeUser({ ...user, forcePasswordChange: false });
                handleClose();
            }
        });
        // eslint-disable-next-line
    }, [user]);


    return (
        <Dialog 
            open={!!user?.forcePasswordChange || open}
            handleClose={handleClose}
            title={title}
            fullWidth={true}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className={!user?.forcePasswordChange ? 'dialogactions-spacebetween' : 'dialogactions-flexend'}
            showCloseButton={!user?.forcePasswordChange}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('currentPassword')}
                        name='currentPassword'
                        value={currentPassword}
                        required={true}
                        onChange={e => ValidationHelper.MaxLength(e.target.value.trim(), 20, setCurrentPassword)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('newPassword')}
                        name='newPassword'
                        value={newPassword}
                        required={true}
                        onChange={e => ValidationHelper.MaxLength(e.target.value.trim(), 20, setNewPassword)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        type='password'
                        label={translate('repeatNewPassword')}
                        name='repeatNewPassword'
                        value={repeatNewPassword}
                        required={true}
                        onChange={e => ValidationHelper.MaxLength(e.target.value.trim(), 20, setRepeatNewPassword)}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default ChangePasswordDialog;